/** An optional text field from a form: trimmed, with an empty value meaning "clear it" (`null`). */
export function optionalText(value: string | null | undefined): string | null {
  const trimmed = (value ?? '').trim();
  return trimmed === '' ? null : trimmed;
}
